export function reorderList(order: number, list: any) {
  if (order <= 0) {
    return list;
  }

  const startToTarget = list.slice(0, order - 1);

  const targetToEnd = list.slice(order - 1, list.length);

  return [...targetToEnd, ...startToTarget];
}
